import { CustomersModel } from './../../models/customers-model';
import { CustomersService } from './../../services/customers.service';
import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';       /// Change Language
import { Router } from '@angular/router';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { LkpStoresService } from 'src/app/services/LkpStoresService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';
import { StockTrnDetModel, StockTrnHDModel } from 'src/app/models/StockTrnModel';
import { StockTrnService } from 'src/app/services/StockTrnService';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { InvoiceSearchComponent } from '../invoice-search/invoice-search.component';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { AccInvoiceEditComponent } from '../acc-invoice-edit/acc-invoice-edit.component';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { URLsConfig } from 'src/app/URLsConfig';
import swal from 'sweetalert2';
import { ItemsService } from 'src/app/services/ItemsService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemssearchComponent } from '../itemssearch/itemssearch.component';
import { CustomersSearchComponent } from '../customers-search/customers-search.component';

@Component({
  selector: 'app-acc-invoice',
  templateUrl: './acc-invoice.component.html',
  styleUrls: ['./acc-invoice.component.css']
})
export class AccInvoiceComponent implements OnInit {
  hedtype = '21' ;
  hedserial = 0 ;
  heddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  hedsup_client = '' ;
  patientName = '';
  hedroomnumber = '' ;
  hedprogramno = '' ;
  hedtax1 = '' ;
  hedtax2 = '' ;
  heddisc1 = 0 ;
  heddisc2 = 0 ;
  hedstore = '1' ;
  hedtostore = '' ;
  heddoctor = '' ;
  heddescription = '' ;
  hedpost = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  dettype = '21' ;
  detserial = 0 ;
  detline = 0 ;
  detitem = '' ;

  detitemname = '' ;
  detqty = 1 ;
  detprice = 0 ;
  detvalue = 0 ;
  detdescription = '' ;
  heddoctor_Name = '';

  storesList: LkpStoresModel[] = [];
  roomsList: RoomsModel[] = [];
  stocktrndetList: StockTrnDetModel[] = [];
  stockdet : StockTrnDetModel[] = [];

  Wk_total = 0;
  Wk_Net_Value = 0;
  Wk_Last_Serial = 0;
  wk_Color = 'black'
  refared = 'COC';

  customer ='Patient';

  constructor( public storage: LocalStorageService,
    private dialogref: MatDialog,
    public translate: TranslateService,
    public route: Router,
    public urlsConfig :URLsConfig,
    public storesservice : LkpStoresService,
    public itemsservice :ItemsService,
    public roomsService :RoomsService,
    public doctorSelectedData : DoctorsModel,
    public items : ItemsModel,
    public stocktrnhdservicse : StockTrnService,
    public stocktrnservicse : StockTrnService,
    public stocktrndet : StockTrnDetModel,
    public dataBankService : DataBankService,
    public doctorsService : DoctorsService,
    public stocktrnhd : StockTrnHDModel,
    public patientsSelectedData : DatabankModel,
    public patientsdData : DatabankModel,
    public CustomersService : CustomersService,
    public customers : CustomersModel
   ) { }

  ngOnInit(): void {

     this.customer =
      this.storage.retrieve('stgCompCode') === '10'
        ? 'Customer'
        : 'Patient';

    this.retriveRoomsLookupTop();
    this.retriveStoresLookupTop();

    this.translate.use('ar');
    document.documentElement.dir = "rtl";


    if(this.storage.retrieve('stgSerial') != ''){
      this.hedserial = this.storage.retrieve('stgSerial').toString();
      this.hedtype = '21';
      this.retriveStockHd();
    }
    else
    {
     this.retriveNextSerial();
    }


  }

  retriveNextSerial() {
    console.log("Company",this.storage.retrieve('stgcompCode'))
    this.stocktrnhdservicse.GetStockTrnHdSerial(this.hedtype, this.storage.retrieve('stgcompCode')).subscribe((
      data: StockTrnHDModel) => {

      this.hedserial = data.hedserial + 1;
    });

  }
  retriveStoresLookupTop() {
    this.storesList = [];
    this.storesservice.LkpStoresLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: LkpStoresModel[]) => {
      for (let i = 0; i < data.length; i++) {
         this.storesList[i] = data[i];
         this.hedstore = data[i].strcode;

      }

    })
  }
  retriveRoomsLookupTop() {
    this.roomsService
      .getRoomsLookupTop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: RoomsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.roomsList[i] = data[i];
        }

      });
  }
openDialogDoctor(){
const dialogRef = this.dialogref.open(DoctorssearchComponent,
    {
      data: {
        dataKey: this.doctorSelectedData,
        type : this.hedsup_client,
      },
      width: '45vw',
    });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
    dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.heddoctor = result.docCode;
      this.heddoctor_Name = result.docName;
      this.refared = result.referedfrom;
      this.retrivedoctors();
      dialogSubmitSubscription.unsubscribe();
    });
}
retrivedoctors(){

  this.heddoctor_Name = '';
  this.doctorsService.getdoctors(this.heddoctor,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {
    this.heddoctor_Name = data.docName;
  }
  );
}
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
////////****************** New Approuch ********************************/
  RetriveItems(itemInput: HTMLInputElement){
    /////////----------------------- التأكد من ان الصنف غير مكرر -----------------------------------
    for (let i = 0; i < this.stocktrndetList.length; i++) {
      if (this.stocktrndetList[i].detitem.toLowerCase() == this.detitem.toLowerCase()){ this.messagewarrning();return; }

     }
      this.detitemname = '';

      this.detprice = 0;
      this.detvalue = this.detqty * this.detprice;
      this.detdescription = '';
      this.wk_Color = 'black'
this.itemsservice.getitems(this.detitem,this.storage.retrieve('stgcompCode')).subscribe({
  next: (data: ItemsModel) => {
    if (data && data.itTName) {
      this.detitemname = data.itTName;
      this.detprice = data.iTMedical;
      this.getvalue();
      if (this.detline == 0) {
        this.detline = this.Wk_Last_Serial + 1;
      }
    } else {
      this.detitemname = 'E R R O R';
      this.detprice = 0;
       this.wk_Color = 'red';
        setTimeout(() => {
    itemInput.focus();
  }, 0);
    }
  },
  error: (err) => {
    console.error('Item not found or server error', err);
    this.detitemname = 'E R R O R';
    this.detprice = 0;
          this.wk_Color = 'red';
           setTimeout(() => {
    itemInput.focus();
  }, 0);
  }
});


  }
  getvalue(){
    this.detvalue = this.detqty * this.detprice;
  }
  submitLine(itemInput: HTMLInputElement){

    if (this.detitem == '' || this.detitem == null || this.detitemname == '' || this.detitemname == null) {
      return;
    }

    this.stocktrndet.dettype = this.dettype;
    this.stocktrndet.detserial = this.hedserial;
    this.stocktrndet.detline = this.detline;
    this.stocktrndet.detitem = this.detitem;
    this.stocktrndet.detitemname = this.detitemname;
    this.stocktrndet.detqty = this.detqty;
    this.stocktrndet.detprice = this.detprice;
    this.stocktrndet.detvalue = this.detvalue;
    this.stocktrndet.detdescription = this.detdescription;

    this.stocktrndet.userid = this.storage.retrieve('stguserId');
    this.stocktrndet.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.stocktrndet.compcode = this.storage.retrieve('stgcompcode');
    this.stocktrnservicse.AddStockTrnDet(this.stocktrndet).subscribe(data => {

      this.detline = 0;
      this.detitem = '';
      this.detitemname = '';
      this.detqty =1;
      this.detprice =0;
      this.detvalue =0;
      this.detdescription ='';
      this.retriveStockTrnDet()

    },
      error => { alert(error); }
    );
    setTimeout(() => {
    itemInput.focus();
  }, 0);
  }
  OpenDialogItem(){

    const dialogRef = this.dialogref.open(ItemssearchComponent,
          {
            data: {
              dataKey: this.items,

            }
          });

        dialogRef.afterClosed().subscribe(result => {

        });

        const dialogSubmitSubscription =

        dialogRef.componentInstance.submitClicked.subscribe(result => {
          for (let i = 0; i < this.stockdet.length; i++) {
            if (this.stockdet[i].detitem.toLowerCase() == result.itCode.toLowerCase()){ this.messagewarrning();return; }

             }
            this.detitem = result.itCode;
            this.detitemname = result.itTName;
            this.detprice = result.iTMedical;

            this.getvalue();
             if (this.detline ==0){this.detline = this.Wk_Last_Serial + 1}
            dialogSubmitSubscription.unsubscribe();
          });

  }
  Edit_Line(pro :StockTrnDetModel){

            this.dettype = this.hedtype;
            this.detserial =  this.hedserial;
            this.detline = pro.detline;
            this.detitem = pro.detitem;
            this.detitemname = pro.detitemname;
            this.detqty = pro.detqty;
            this.detprice = pro.detprice;
            this.detvalue = pro.detvalue;
            this.detdescription = pro.detdescription;

      //  this.retriveStockTrnDet();
  }
  DeleteLine(){


            this.stocktrnservicse.DelStockTrnDetLine(this.dettype, this.hedserial.toString(),this.detline.toString(), this.storage.retrieve('stgcompCode')).subscribe((data: StockTrnDetModel) => {
               this.retriveStockTrnDet();
             this.detline = 0;
            });



  }
mesgDelete(pro :StockTrnDetModel){
   swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.detline = pro.detline;
          this.DeleteLine();
          swal('Deleted!', 'Your record has been deleted.', 'success');

        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );

  }
  /////*********************************************************************************************** */
  retriveStockHd() {

    this.stocktrnhdservicse.GetStockTrnHD(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
      (data: StockTrnHDModel) => {

        this.heddate =  formatDate(data.heddate, 'yyyy-MM-dd', 'en');
        this.hedsup_client = data.hedsup_client;

        if(this.storage.retrieve('stgcompCode') !='10') this.RetrivePatient();
        if(this.storage.retrieve('stgcompCode') =='10') this.RetriveCustomer();


        this.hedtostore = data.hedtostore;
        this.hedroomnumber = data.hedroomnumber;
        this.hedprogramno = data.hedprogramno;

        this.hedtax1 = data.hedtax1;
        this.hedtax2 = data.hedtax2;
        this.heddisc1 = data.heddisc1;
        this.heddisc2 = data.heddisc2;
        this.hedstore = data.hedstore;
        this.hedtostore= data.hedtostore;
        this.heddescription = data.heddescription;
        this.heddoctor = data.heddoctor;
        this.retrivedoctors();
        this.retriveStockTrnDet();

      }
    );
  }
  retriveStockTrnDet() {
    this.stocktrndetList = [];
    this. Wk_total =0;
    this.stocktrnhdservicse.GetStockTrnDet(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe((data: StockTrnDetModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.stocktrndetList[i] = data[i];
        this.stocktrndetList[i].detitemname = data[i].detitemname;
        this. Wk_total =this. Wk_total  +  data[i].detvalue;
        this.Wk_Last_Serial = data[i].detline;
        this.detline =0;
      }
      this.Wk_Net_Value =  this. Wk_total  - this.heddisc1;
    })

  }
  openDialogSerial(){
    const dialogRef = this.dialogref.open(InvoiceSearchComponent,
      {
        data: {
          dataKey: this.stocktrnhd,
          hedtype : this.hedtype
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.hedserial = result.hedserial;

        this.retriveStockHd();
        dialogSubmitSubscription.unsubscribe();

      });
  }

  openDialogPatient(){
if (this.storage.retrieve(('stgCompCode')) === '10'){
      const dialogRef = this.dialogref.open(CustomersSearchComponent,
          {
            data: {
              dataKey: this.patientsSelectedData
            },
             width: '80%',
        });
        dialogRef.afterClosed().subscribe(result => {});
           const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe((result) => {
      this.hedsup_client = result.patientCode;
      this.RetriveCustomer();

       dialogSubmitSubscription.unsubscribe();

     });

      } else {

    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {

      data: {

        dataKey: this.patientsSelectedData,
      },
      width: '80%',
    });
debugger
    dialogRef.afterClosed().subscribe((result) => {});

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.hedsup_client = result.patientCode;
        this.RetrivePatient();

        dialogSubmitSubscription.unsubscribe();

      });
      }
  }

  submitInvoice(){
    if (this.hedserial == 0 || this.hedserial == null) {
      return;
    }

    this.stocktrnhd.hedtype = this.hedtype;
    this.stocktrnhd.hedserial = this.hedserial;
    this.stocktrnhd.heddate = formatDate(this.heddate, 'yyyy-MM-dd', 'en');
    this.stocktrnhd.hedsup_client = this.hedsup_client;
    this.stocktrnhd.hedroomnumber = this.hedroomnumber;
    this.stocktrnhd.hedprogramno = this.hedprogramno;
    this.stocktrnhd.hedstore = this.hedstore;
    this.stocktrnhd.hedtostore = this.hedtostore;
    this.stocktrnhd.hedtax1 = this.hedtax1;
    this.stocktrnhd.hedtax2 = this.hedtax2;
    this.stocktrnhd.heddisc1 = this.heddisc1;
    this.stocktrnhd.heddisc2 = this.heddisc2;
    this.stocktrnhd.heddescription = this.heddescription;
    this.stocktrnhd.hedpost = this.hedpost;
    this.stocktrnhd.heddoctor = this.heddoctor;
    this.stocktrnhd.userid = this.storage.retrieve('stguserId');
    this.stocktrnhd.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.stocktrnhd.compcode = this.storage.retrieve('stgcompcode');



    this.dataBankService.UpdatePatientReferd(this.hedsup_client,this.refared, this.storage.retrieve('stgcompcode')).subscribe(data => { },

      error => { alert(error); }
    );

    this.stocktrnhdservicse.AddStockTrnHD(this.stocktrnhd).subscribe(data => {
      this.mesgSave()
    },

      error => { alert(error); }
    );


  }
  DeleteInvoice(){
    this.stocktrnhdservicse.DelStockTrnHD(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
      (data: StockTrnHDModel) => {
      }
    );

    this.stocktrnhdservicse.DelStockTrnDet(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
      (data: StockTrnDetModel) => {
      }
    );
    this.NewData();

  }
  MesgDelete(){
      Swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.DeleteInvoice();
          Swal('Deleted!', 'Your record has been deleted.', 'success');
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            Swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );


  }
  NewData(){
    debugger;
      this.hedtype = '21' ;
      this.hedserial = 0 ;
      this.heddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.hedsup_client = '' ;
      this.patientName = '';
      this.hedroomnumber = '' ;
      this.hedprogramno = '' ;
      this.hedtax1 = '' ;
      this.hedtax2 = '' ;
      this.heddisc1 = 0 ;
      this.heddisc2 = 0 ;
      this.hedstore = '1' ;
      this.hedtostore = '' ;
      this.heddoctor = '' ;
      this.heddoctor_Name ='';
      this.heddescription = '' ;
      this.hedpost = '' ;

      this.dettype = '21' ;
      this.detserial = 0 ;
      this.detline = 0 ;
      this.detitem = '' ;

      this.detitemname = '' ;
      this.detqty = 1 ;
      this.detprice = 0 ;
      this.detvalue = 0 ;
      this.detdescription = '' ;
      this.stocktrndetList = [];
      this. Wk_Net_Value = 0;
      this.Wk_total = 0;
      this.Wk_Last_Serial = 0;
      this.retriveNextSerial();
      this.storage.store('stgSerial','');
  }
  ReportInvoice(){
    this.storage.store('stgSerial', this.hedserial);
    this.storage.store('stgCompCode', this.compcode);
    this.submitInvoice();
  //  this.route.navigate(['report-vewier','CocReports/Invoice']);


      const compcode = this.storage.retrieve('stgcompCode').trim();
      const repPathEng1 = this.urlsConfig.WebRepor_ServertURL_Focu + 'Invoice' + '&rs:Command=Render&Serial=' + this.hedserial;

      window.open(repPathEng1, '_blank', 'scrollbars=yes,resizable=yes,toolbar=yes,menubar=yes');

  }

  RetrivePatient(){
    this.dataBankService.getPatient(this.hedsup_client,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.patientName = data.patientFName;
      this.heddoctor = data.docCode;
      this.refared = data.referredfrom;


      this.retrivedoctors();
    })
  }
  SelectLine(pro : StockTrnDetModel){
    this.submitInvoice();
    const dialogRef = this.dialogref.open(AccInvoiceEditComponent,
        {
          data: {
            dataKey: this.stocktrndetList,
            stockdet:this.stocktrndetList,
            dettype : this.hedtype,
            detserial: this.hedserial,
            detline: pro.detline,
            detitem: pro.detitem,
            detitemname: pro.detitemname,
            detqty: pro.detqty,
            detprice: pro.detprice,
            detvalue: pro.detvalue,
            detdescription: pro.detdescription

          },
          width: '70vw',

        });
      dialogRef.afterClosed().subscribe(result => {
        this.retriveStockTrnDet();
      });
      this.retriveStockTrnDet();
  }
  New_Line(){
    this.submitInvoice();
    const dialogRef = this.dialogref.open(AccInvoiceEditComponent,
        {
          data: {
            dataKey: this.stocktrndetList,
            stockdet:this.stocktrndetList,
            dettype : this.hedtype,
            detserial: this.hedserial,
            detline: this.Wk_Last_Serial + 1,
            detitem: '',
            detitemname: '',
            detqty: 1,
            detprice: 0,
            detvalue: 0,
            detstatus: 'New'

          },
          width: '70vw',

        });
      dialogRef.afterClosed().subscribe(result => {
        this.retriveStockTrnDet();
      });
      this.retriveStockTrnDet();
  }
  ClucDiscPer(){
    this.Wk_Net_Value =  this. Wk_total  - this.heddisc1;
  }
  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
  Revenue(){
    this.storage.store('stgValue',this.Wk_Net_Value);
    this.storage.store('stgPatientCode',this.hedsup_client);
    this.storage.store('stgPatientName',this.patientName);
    this.submitInvoice();
  }
   messagewarrning(){
      swal({
        title: 'هذا البند مكرر .... نرجو التأكد',
        type: 'error',
        showConfirmButton: false,

        timer: 2500,
      });

    }

      RetriveCustomer(){
      this.CustomersService.getPatient(this.hedsup_client,this.storage.retrieve('stgcompCode')).subscribe((data: CustomersModel) => {
      this.patientName = data.patientFName;

      this.refared = data.referredfrom;


      this.retrivedoctors();
    })
  }
}
